import '../../nuevoStro/Light/nuevoStroLight.css'
import FrentePdf from "../../pdf/Frente";
import PDF from "../../pdf/Sicobe";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { useCallback, useState } from 'react';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import sharepoint from '../../../images/sharepoint.jpeg'
import sharepointRojo from '../../../images/shareRojo.png'
import { Link } from 'react-router-dom';
import DocumentosNubeLight from '../../nuevoStro/Light/DocumentosNubeLight';
export default function MainStroCargasLight({ stro, carga3, estados, estadosCodigos, frente, sicobe, carga2, pagosAnteriores, cobert, getLabelsFromValues, responsabilidadInput, responsabilidad, handleChange1, obs, setObs, stroRechazado, stroPosibleDuplicado, stroAmpliacion, cargando, stroCargado, docu, handleChangeFotos, handleChangeCedula, handleChangeCroquis, handleChangeRelato, handleChangeDanios, handleChangeRegistro, handleChangeDenunciaPol, setDocu, check }) {
    const [cookies] = useCookies(["user"], ['asignado']);
    function formatDate(inputDate) {
        const date = new Date(inputDate);
        const day = String(date.getUTCDate()).padStart(2, "0");
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const year = date.getUTCFullYear();
        return `${day}/${month}/${year}`;
    }
    const [link1, setLink1] = useState({ link: stro?.link });
    const linkUpdate = useCallback(async (e) => {
        e.preventDefault()
        await axios.post(`https://back.agsseguros.online/api/denuncia/linkSharepoint`,
            {
                id: stro.id,
                link: link1.link,
            }
        ).then((response) => {
            if (response) {
                window.location.reload()
            }
        })
    }, [stro, link1]);
    const logo = { height: '26px', width: '26px' }
    const handleLinkClick = (event) => {
        if (!stro.link.startsWith('http')) {
            event.preventDefault();
            window.open(`https://${stro.link}`, '_blank');
        }
    };
    function formatDate(inputDate) {
        const date = new Date(inputDate);
        const day = String(date.getUTCDate()).padStart(2, "0");
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const year = date.getUTCFullYear();
        return `${day}/${month}/${year}`;
    }
    const qnxInic = formatDate(stro?.qnx?.ados_fech_ini);
    const qnxFin = formatDate(stro?.qnx?.ados_fech_fin);
    const openInNewTab = (url, e) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    const fechaStro = formatDate(stro?.fechaStro);
    const parseDate = (dateStr) => {
        const [day, month, year] = dateStr.split('/');
        return new Date(`${year}-${month}-${day}`);
    };
    const isDateBetween = (date, startDate, endDate) => {
        const dateToCheck = parseDate(date);
        const start = parseDate(startDate);
        const end = parseDate(endDate);

        const isSameDay = (d1, d2) => (
            d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate()
        );

        if (isSameDay(dateToCheck, start) || isSameDay(dateToCheck, end)) {
            return false;
        }

        return dateToCheck > start && dateToCheck < end;
    };
    return (
        <section className='mainStroDarkContenedor'>
            <section className='mainStroLightColIzq'>
                <section className='moduloActualizacionStro1LightContainer' style={{ paddingBottom: '30px' }}>
                    <div className='d-flex justify-content-between'>
                        <div className='d-flex gap-3'>
                            <h2 className=''>Base AGS</h2>
                            {carga2 ?
                                <PDFDownloadLink document={<FrentePdf denuncia={frente} />} fileName={`frenteStro${stro?.nroStro?.toString().substring(3)}.pdf`} style={{ textDecoration: 'none' }}>
                                    {({ loading, url, error, blob }) =>
                                        <div className='center'><button id="botonFrente" className='btnDescargarFrenteDark'>FRENTE</button></div>
                                    }
                                </PDFDownloadLink> : null}
                            {carga2 && stro.nroStro ?
                                <PDFDownloadLink document={<PDF sicobe={sicobe} pagosAnteriores={pagosAnteriores} cobert={cobert} cobertura={stro?.qnx?.ados_cobert} />} fileName={`sicobeStro${stro?.nroStro?.toString().substring(3)}.pdf`} style={{ textDecoration: 'none' }}>
                                    {({ loading, url, error, blob }) => <div className='center'><button id="botonSicobe" className='btnDescargarSicobeLight'>SICOBE</button></div>}
                                </PDFDownloadLink> : null}
                        </div>
                        <div className='d-flex gap-3'>
                            {stro.link ?
                                <div className='center'>
                                    <a href={`${stro.link}`} target="_blank" rel="noopener noreferrer" onClick={handleLinkClick}>
                                        <img src={sharepoint} alt="" style={logo} />
                                    </a>
                                </div> :
                                <div className='center'>
                                    <button className='btnNO' data-bs-toggle="modal" data-bs-target="#exampleModal">
                                        <img src={sharepointRojo} alt="" style={logo} />
                                    </button>
                                </div>}
                            <div class="modal fade mt-5" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div class="modal-dialog">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title" id="exampleModalLabel">Link Sharepoint</h5>
                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                        </div>
                                        <div class="modal-body">
                                            <input type="text" className='w-100 ps-3' onChange={(e) =>
                                                setLink1((prevState) => ({
                                                    ...prevState,
                                                    link: e.target.value,
                                                }))} />
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                                            <button type="button" class="btn btn-primary" onClick={(e) => linkUpdate(e)}>Actualizar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {stro.nroStro !== null ?
                                <div className=''>
                                    <a href={`https://ags.webmanager.com.ar/LinkAuth/${cookies.user.digi}/QWdzbmV0MDgxMQ==/${stro.nroStro.toString().substring(3)}`} target="_blank"><i class="bi bi-file-earmark-text" style={{ fontSize: '26px', color: '#42C3BA' }}></i></a>
                                </div> : <></>}
                        </div>
                    </div>
                    <div className='d-flex gap-3' style={{ marginTop: '20px' }}>
                        <div className='d-flex w-100'>
                            <span className='spanBurbujaTextoStroLight'>Vigencia</span>
                            <div className='burbujaTextoStroLight d-flex'>
                                <div style={{ width: '50%' }}>{qnxInic}</div>
                                <div style={{ width: '50%' }}>{qnxFin}</div>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex gap-3' style={{ marginTop: '25px' }}>
                        <div className='d-flex w-100'>
                            <span className='spanBurbujaTextoStroLight'>Poliza</span>
                            <div className='burbujaTextoStroLight'><Link onClick={(e) => openInNewTab(`https://www.agsnet.com.ar/muestro-polizas2.php?prop=${stro?.qnx?.ados_nro_cc}&rtn=consulta-polizas`)}>{stro?.qnx?.ados_poliza}</Link></div>
                        </div>
                    </div>
                    <div className='' style={{ marginTop: '25px' }}>
                        <div className='d-flex w-100'>
                            <span className='spanBurbujaTextoStroLight'>Nombre Aseg</span>
                            <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_nom_aseg}</div>
                        </div>
                    </div>
                    <div className='d-flex gap-3' style={{ marginTop: '25px' }}>
                        <div className='d-flex w-100'>
                            <span className='spanBurbujaTextoStroLight'>Patente</span>
                            <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_patente}</div>
                        </div>
                    </div>
                    <div className='' style={{ marginTop: '25px' }}>
                        <div className='d-flex w-100'>
                            <span className='spanBurbujaTextoStroLight'>Marca</span>
                            <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_vehiculo} - ${stro?.qnx?.ados_modelo}</div>
                        </div>
                    </div>
                    <div className='d-flex gap-3' style={{ marginTop: '25px' }}>
                        <div className='d-flex w-100'>
                            <span className='spanBurbujaTextoStroLight'>Modelo</span>
                            <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_modelo}</div>
                        </div>
                    </div>
                </section>
                <section className='moduloActualizacionStro1LightContainer' style={{ paddingBottom: '30px' }}>
                    <div className='d-flex gap-3' style={{ marginTop: '20px' }}>
                        <div className='d-flex w-100'>
                            <span className='spanBurbujaTextoStroLight'>Fecha Carga</span>
                            <div className='burbujaTextoStroLight'>{stro.nroStro !== null ? formatDate(stro.fechaCarga) : ''}</div>
                        </div>
                        <div className='d-flex w-100'>
                            <span className='spanBurbujaTextoStroLight'>Fecha Sello</span>
                            <div className='burbujaTextoStroLight'>{formatDate(stro.fechaDenuncia)}</div>
                        </div>
                    </div>
                    <div className='d-flex gap-3' style={{ marginTop: '20px' }}>
                        <div className='d-flex w-100'>
                            <span className='spanBurbujaTextoStroLight'>Responsabilidad</span>
                            {stro.catStro !== null ?
                                <div className="burbujaTextoStroLight d-flex align-items-center">
                                    {getLabelsFromValues(stro?.catStro, responsabilidadInput)}
                                </div> :
                                <select value={responsabilidad} onChange={handleChange1} className="select1 m-0" style={{ height: '48px', width: '100%' }}>
                                    <option value="">Select...</option>
                                    {responsabilidadInput.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>}
                        </div>
                        <div className='d-flex w-100'>
                            <span className='spanBurbujaTextoStroLight'>Vigencia</span>
                            <div style={{ border: 'none' }} className={isDateBetween(fechaStro, qnxInic, qnxFin) ? "btnCoberturaFechaCargaHeaderStro text-center center text-white" : "btnCoberturaFechaCargaHeaderStroRojo text-center center text-white"}>{isDateBetween(fechaStro, qnxInic, qnxFin) ? "Vigencia" : "Sin Vigencia"}</div>
                        </div>
                    </div>
                    <div className='d-flex gap-3' style={{ marginTop: '20px' }}>
                        <div className=' w-100'>
                            <span className='spanBurbujaTextoStroLight'>Observaciones</span>
                            <textarea
                                className="burbujaModuloActualizacionStro1Light burbujaModuloActualizacionStro1Dark3"
                                value={obs}
                                onChange={(e) =>
                                    setObs(e.target.value)
                                }
                            />
                        </div>
                    </div>
                    <div className="div1StroHeader2 row">
                        <div className="d-flex justify-content-end gap-3">
                            <div className="btnSolicitudFecha center" style={{ backgroundColor: 'orange' }}>
                                <button className="btnNO text-white btnFechasCargasStro" onClick={(e) => stroPosibleDuplicado(e)}>POSIBLE DUPLICADO</button>
                            </div>
                            <div className="btnSolicitudFecha center">
                                <button className="btnNO text-white btnFechasCargasStro" onClick={(e) => stroRechazado(e)}>RECHAZAR</button>
                            </div>
                            <div className="btnDenunciaInc center">
                                <button
                                    className="btnNO text-white btnFechasCargasStro"
                                    onClick={(e) => stroAmpliacion(e)}
                                    disabled={
                                        docu.cedula === "" &&
                                            docu.croquis === "" &&
                                            docu.danios === "" &&
                                            docu.denunciaPol === "" &&
                                            docu.fotos === "" &&
                                            docu.otros === "" &&
                                            docu.registro === "" &&
                                            docu.relato === ""
                                            ? true
                                            : false
                                    }
                                >
                                    DENUNCIA INC
                                </button>
                            </div>
                            <div className="btnCargarStro center">
                                <button className="btnNO text-white btnFechasCargasStro"
                                    disabled={cargando === false ? true : (stro.nroStro !== null ? true : (responsabilidad === null ? true : (responsabilidad === '' ? true : false)))}
                                    onClick={(e) => stroCargado(e)}>
                                    {cargando === true ? 'CARGAR STRO' : <div className="center"><div class="spinner-border text-white center" role="status"><span class="visually-hidden center">Loading...</span></div></div>}
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
            <section className='mainStroLightColDer'>
                <section className='mainStroLightIzq'>
                <div className="d-flex justify-content-between align-items-center pt-2 pe-4">
                    <h2 className="">Denuncia Administrativa</h2>
                </div>
                <div className="d-flex align-items-center infoStroElemento">
                    <label className="spanBurbujaTextoStroLight">Fecha Stro</label>
                    <div className="burbujaTextoStroLight">{formatDate(stro.fechaStro)}</div>
                </div>
                <div className="d-flex align-items-center infoStroElemento">
                    <label className="spanBurbujaTextoStroLight">Poliza</label>
                    <div className={Number(stro?.pza) === Number(stro?.qnx?.ados_poliza) ? "burbujaTextoStroLight" : 'burbujaTextoStroLight border-danger'}>{stro?.pza}</div>
                </div>
                <div className="d-flex align-items-center infoStroElemento">
                    <label className="spanBurbujaTextoStroLight">Nombre Aseg</label>
                    <div className={stro?.nombreAseg === stro?.qnx?.ados_nom_aseg ? "burbujaTextoStroLight" : 'burbujaTextoStroLight border-danger'}>{stro?.nombreAseg} </div>
                </div>
                <div className="d-flex align-items-center infoStroElemento">
                    <label className="spanBurbujaTextoStroLight">Patente</label>
                    <div className={stro?.dom === stro?.qnx?.ados_patente ? "burbujaTextoStroLight" : 'burbujaTextoStroLight border-danger'}>{stro?.dom} </div>
                </div>
                <div className="d-flex align-items-center infoStroElemento">
                    <label className="spanBurbujaTextoStroLight">Marca</label>
                    <div className="burbujaTextoStroLight">{stro?.marcaAseg} </div>
                </div>
                <div className="d-flex align-items-center infoStroElemento">
                    <label className="spanBurbujaTextoStroLight">Modelo</label>
                    <div className="burbujaTextoStroLight">{stro?.modeloAseg}</div>
                </div>
                <div className="d-flex align-items-start infoStroElemento">
                    <label className="spanBurbujaTextoStroLight">Relato</label>
                    <div className="burbujaTextoStroLight burbujaAdaptable">{stro?.detallesStro}</div>
                </div>
                <div className="d-flex align-items-start infoStroElemento">
                    <label className="spanBurbujaTextoStroLight">Daños</label>
                    <div className="burbujaTextoStroLight">{stro?.detallesDaniosAseg} </div>
                </div>
                <hr className="text-white" />
                <section className="mt-3">
                    <div className="d-flex gap-2">
                        <div className="d-flex align-items-center">
                            <input
                                type="checkbox"
                                name=""
                                id=""
                                onChange={handleChangeFotos}
                                checked={check.fotos}
                                class="form-check-input me-1"
                            />
                            <label htmlFor="" className="spanBurbujaTextoStroLight" style={{ width: 'inherit' }}
                            >
                                FOTOS
                            </label>
                        </div>
                        <div className="d-flex align-items-center">
                            <input
                                type="checkbox"
                                name=""
                                id=""
                                class="form-check-input me-1"
                                onChange={handleChangeCedula}
                                checked={check.cedula}
                            />
                            <label htmlFor="" className="spanBurbujaTextoStroLight" style={{ width: 'inherit' }}
                            >
                                CEDULA
                            </label>
                        </div>
                        <div className="d-flex align-items-center">
                            <input
                                type="checkbox"
                                name=""
                                id=""
                                class="form-check-input me-1"
                                onChange={handleChangeCroquis}
                                checked={check.croquis}
                            />
                            <label htmlFor="" className="spanBurbujaTextoStroLight" style={{ width: 'inherit' }}
                            >
                                CROQUIS
                            </label>
                        </div>
                        <div className="d-flex align-items-center">
                            <input
                                type="checkbox"
                                name=""
                                id=""
                                class="form-check-input me-1"
                                onChange={handleChangeRelato}
                                checked={check.relato}
                            />
                            <label htmlFor="" className="spanBurbujaTextoStroLight" style={{ width: 'inherit' }}
                            >
                                RELATO
                            </label>
                        </div>
                        <div className="d-flex align-items-center">
                            <input
                                type="checkbox"
                                name=""
                                id=""
                                class="form-check-input me-1"
                                onChange={handleChangeDanios}
                                checked={check.danios}
                            />
                            <label htmlFor="" className="spanBurbujaTextoStroLight" style={{ width: 'inherit' }}                            >
                                DAÑOS
                            </label>
                        </div>
                        <div className="d-flex align-items-center">
                            <input
                                type="checkbox"
                                name=""
                                id=""
                                class="form-check-input me-1"
                                onChange={handleChangeRegistro}
                                checked={check.registro}
                            />
                            <label htmlFor="" className="spanBurbujaTextoStroLight" style={{ width: 'inherit' }}
                            >
                                REGISTRO
                            </label>
                        </div>
                        <div className="d-flex align-items-center">
                            <input
                                type="checkbox"
                                name=""
                                id=""
                                class="form-check-input me-1"
                                onChange={handleChangeDenunciaPol}
                                checked={check.denunciaPol}
                            />
                            <label htmlFor="" className="spanBurbujaTextoStroLight" style={{ width: 'inherit' }}
                            >
                                DENUNCIA POL
                            </label>
                        </div>
                    </div>
                    <div className="mt-2">
                        <label className="spanBurbujaTextoStroLight d-block">OTROS</label>
                        <textarea
                            className="burbujaTextoStroLight burbujaModuloActualizacionStro1Dark3"
                            value={docu.otros}
                            onChange={(e) =>
                                setDocu((prevState) => ({
                                    ...prevState,
                                    otros: e.target.value,
                                }))
                            }
                        />
                    </div>
                </section>
            </section>
                <DocumentosNubeLight stro={stro} />
            </section>
        </section>
    );
}